import { render, staticRenderFns } from "./OutputField.vue?vue&type=template&id=23bfcb96&scoped=true&"
import script from "./OutputField.vue?vue&type=script&lang=js&"
export * from "./OutputField.vue?vue&type=script&lang=js&"
import style0 from "./OutputField.vue?vue&type=style&index=0&id=23bfcb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bfcb96",
  null
  
)

export default component.exports